/* eslint-disable no-shadow */
import React from "react";
import PropTypes from "prop-types";
import Parser from "html-react-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { toggleTermsModal } from "../../actions/subscriptionPlansActions";
import Loading from "../shared/loaders/Loading";
import Button from "../shared/button/Button";
import {
  ModalBackdrop,
  Modal,
  Title,
  TitleText,
  CloseButton,
  BodyWrapper,
  Body,
  ButtonWrapper,
  Text,
} from "./styles/terms-of-business-styles";

export const TermsOfBusiness = ({
  toggleTermsModal,
  termsOfBusiness,
  termsModalLoading,
  errors,
}) => (
  <ModalBackdrop className="animated fadeIn">
    <Modal className="animated fadeInUp delay">
      {termsModalLoading ? (
        <Loading fontSize="medium" />
      ) : (
        <BodyWrapper className="animated fadeIn">
          <Title>
            <TitleText>Terms of Business</TitleText>
            <CloseButton onClick={() => toggleTermsModal()}>
              <FontAwesomeIcon icon={faTimes} />
            </CloseButton>
          </Title>
          <Body>
            {errors.message && <Text>{errors.message}</Text>}
            {termsOfBusiness && <Text>{Parser(termsOfBusiness)}</Text>}
          </Body>
          <ButtonWrapper>
            <Button
              buttonName="Close"
              primary
              onClickAction={() => toggleTermsModal()}
            />
          </ButtonWrapper>
        </BodyWrapper>
      )}
    </Modal>
  </ModalBackdrop>
);

TermsOfBusiness.propTypes = {
  toggleTermsModal: PropTypes.func.isRequired,
  termsOfBusiness: PropTypes.string,
  termsModalLoading: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    message: PropTypes.string,
  }).isRequired,
};

TermsOfBusiness.defaultProps = {
  termsOfBusiness: PropTypes.isNull,
};

const mapStateToProps = (state) => ({
  termsOfBusiness: state.subscriptionPlans.termsOfBusiness,
  termsModalLoading: state.subscriptionPlans.termsModalLoading,
  errors: state.subscriptionPlans.errors,
});

export default connect(mapStateToProps, { toggleTermsModal })(TermsOfBusiness);
